// group enums, schema, and endpoints in namespaces
import * as additionalEnums from './mixed-types/enums';
import {
  CollectDataSubjectRegions,
  MissingIdBehavior,
  WorkflowCommunicationMethod,
  WorkflowConfigStatus,
  WorkflowInstanceStatus,
  WorkflowPhase,
  WorkflowStepCompletionState,
  WorkflowTrigger,
} from './mixed-types/workflows';
import * as schemaEnums from './schema/enums';

export * from './mixed-types/helpers';

export const enums = {
  ...schemaEnums,
  ...additionalEnums,
  // Workflow Enums
  ...{
    CollectDataSubjectRegions,
    MissingIdBehavior,
    WorkflowCommunicationMethod,
    WorkflowConfigStatus,
    WorkflowInstanceStatus,
    WorkflowPhase,
    WorkflowStepCompletionState,
    WorkflowTrigger,
  },
};
export * as endpoints from './endpoints';
export * as schema from './schema';

// export all at top level
export * from './codecs';
export * from './constants';
export * from './getRequestStepsByType';
export * from './helpers';
export * from './helpers/statuses';
export * from './makeProfileUniqueKey';
export * from './messages';
export * from './mixed-types/workflows';
export * from './routes';
export * from './schema';
export * from './schema/enums';
export * from './typeGuards';
export * from './types';
